
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class FullscreenModal extends Vue {
  @Prop({ type: String, default: "#525FFF" }) mainColor!: String; //主色调
  // @Prop({ default: 0 }) uploadProgress!: number;

  uploadProgress = 0;
  mounted() {
    const interval = setInterval(() => {
      this.uploadProgress += 1;
      this.$forceUpdate();
      if (this.uploadProgress >= 90) {
        clearInterval(interval);
      }
    }, 35);
  }
}
